const InputSanitizerPlugin = {
    install: function (Vue, options) {
        if (!options) {
            options = {};
        }

        const InputSanitizer = function () {
            this.toDigits = function (value) {
                return String(value).replace(/\D/gi, '');
            };

            this.toNumeric = function (value, precision = 2) {
                if (value === '' || value === null || value === undefined) return null;
                const formatter = new Intl.NumberFormat('en-US', {
                    style: 'decimal',
                    useGrouping: false,
                    trailingZeroDisplay: 'stripIfInteger', 
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                let number = String(value).replace(/[^0-9.-]/g, '');
                return formatter.format(Number(number));
            };

            this.toAlpha = function (value) {
                return value.replace(/[^A-Za-z'\- ]/gi, '');
            };

            this.toAlphaNumeric = function (value) {
                return value.replace(/[^A-Za-z0-9'\- ]/gi, '');
            };
        };
        
        Vue.prototype.$inputSanitizer = new InputSanitizer;
    }
};

export default InputSanitizerPlugin;
